import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import '@tcl-boron-fonts/ibm-plex-sans/dist/ibm-plex-sans.css';
import 'isomorphic-fetch';

import './index.css';
import './config/config';
import App from './App.jsx';
import * as serviceWorker from './serviceWorker';
import './polyfills/text-encoding-polyfill';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
